

















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "Gallery"
})
export default class Gallery extends Vue {
  // eslint-disable-next-line
  @Prop() private readonly assets: any;
  @Prop() private readonly category: string | undefined;
  @Prop() private readonly theaterAtStart!: boolean;

  // eslint-disable-next-line
  private photos: any[] = [];
  private theater = false;
  private theaterIndex = -1;
  private isWidescreen = false;

  created() {
    window.addEventListener("resize", this.updateWidescreen);
  }

  destroyed() {
    window.removeEventListener("resize", this.updateWidescreen);
  }

  mounted() {
    this.theater = this.theaterAtStart;
    this.updateWidescreen();
    for (const key in this.assets.photos) {
      if (!this.category || this.assets.photos[key].category == this.category) {
        this.photos.push(this.assets.photos[key]);
        this.theaterIndex = 0;
      }
    }
  }

  private updateWidescreen() {
    this.isWidescreen = window.innerWidth >= 1000;
  }

  private getTheaterRatio() {
    return this.photos[this.theaterIndex].ratio;
  }

  private getTheaterUrl() {
    return this.photos[this.theaterIndex].fullrez;
  }

  private getTheaterAlt() {
    return this.photos[this.theaterIndex].alt;
  }

  private enterGallery() {
    this.theater = false;
  }

  private enterTheater(alt: string) {
    this.theaterIndex = this.photos.findIndex(p => p.alt == alt);
    this.theater = true;
  }

  private next() {
    this.theaterIndex = (this.theaterIndex + 1) % this.photos.length;
  }

  private previous() {
    this.theaterIndex =
      (this.theaterIndex + this.photos.length - 1) % this.photos.length;
  }
}
